/* ============================================================
   PRODUCT INQUIRY DATA
   Built from your notebook photos. A few categories (Solar EPC
   cables, Flexible Wire) didn't have size/brand details in the
   photos yet — marked with TODO below. Send me those specs and
   I'll fill them in the same way as the rest.
   ============================================================ */

const productInquiryData = {
  "Real Estate": {
    "House Wire": {
      brands: {
        // "Lucky (0.210mm / 8.50 Gauge)": ["0.75", "1.00", "1.50", "2.50", "4.00"],
        // "VS (0.230mm / 9.50 Gauge)": ["0.75", "1.00", "1.50", "2.50", "4.00"],
        "Savariya House Wire": ["0.75", "1.00", "1.50", "2.50", "4.00"],
      },
    },

    "Flat Wire (2 core)": {
      brands: {
        "Lucky — 24x20 (0.122mm x 20 core)": ["Standard"],
        "NV — 24x20 (0.122mm x 18 core)": ["Standard"],
        "24x20 (0.102mm x 16 core)": ["Standard"],
        "32x20 (0.122mm x 25 core)": ["Standard"],
      },
    },

    "Halogen Wire": {
      brands: {
        "Ultra Soft (0.230mm / 9.50 Gauge)": ["1.00", "1.50"],
        "Standard (0.210mm / 8.50 Gauge)": ["0.75", "1.00", "1.50"],
      },
    },

    "Service Wire": {
      brands: {
        "Aluminium (3 Core)": [
          "2.50 (1.37mm)",
          "4.00 (1.60mm)",
          "6.00 (2.00mm)",
          "10.00 (2.80mm)",
        ],
      },
    },

    // TODO: Flexible Wire sizes/brand weren't visible in the photos —
    // send me the details and I'll plug them in here.
    "Flexible Wire": {
      brands: {
        "Savariya Flexible Wire": ["Sizes to be confirmed"],
      },
    },

    "Aluminium Round Cable": {
      brands: {
        Standard: ["4mm", "6mm", "10mm", "16mm"],
      },
    },

    "Copper Round Cable": {
      brands: {
        "Savariya (0.230mm / 9.50 Gauge)": [
          "0.50", "0.75", "1.00", "1.50", "2.50", "4.00", "6.00",
        ],
        "Lucky (0.190mm / 7.50 Gauge)": [
          "0.50", "0.75", "1.00", "1.50", "2.50",
        ],
      },
      cores: ["2 Core", "3 Core", "4 Core"],
    },
  },

  // TODO: Solar EPC cable specs (LA / Earthing / DC / EN DC) weren't in the
  // photos yet — send me sizes and brands and I'll fill these the same way.
  "Solar EPC": {
    "LA Cable": { brands: { "Savariya LA Cable": ["Sizes to be confirmed"] } },
    "Earthing Cable": { brands: { "Savariya Earthing Cable": ["Sizes to be confirmed"] } },
    "DC Cable": { brands: { "Savariya DC Cable": ["Sizes to be confirmed"] } },
    "EN DC Cable": { brands: { "Savariya EN DC Cable": ["Sizes to be confirmed"] } },
  },

  Agriculture: {
    "Submersible Cable": {
      brands: {
        "Savariya Submersible Cable": ["1.50", "2.50", "4.00", "6.00"],
      },
    },
  },
};

export default productInquiryData;
